import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
    updateLead,
    updateCalendly,
    updateEstimator,
} from '../utils/Actions';
import { getClosestEstimatorByAddress, getEstimatorById } from '../utils/helpers';

const decodeParamsValue = (encodedValue) => { // that function decodes the URL parameters | to -
    return (encodedValue ?? '').replace(/\|/g, '-');
};

const DecodeParams = () => { // that component decodes the URL parameters and updates the state

    //const estimator = useSelector(state => state.estimator);

    const dispatch = useDispatch();

    const navigate = useNavigate(); // that hook is used to navigate to the home page after the state is updated

    const estimatorCurrent = useSelector(state => state.estimator);

    let { fill } = useParams();

    useEffect(() => {
        void (async () => {
            if (!fill) return;
            const paramsArray = fill.split('-').map(decodeParamsValue);
            const params = {
                firstName: paramsArray?.[0] ?? '',
                lastName: paramsArray?.[1] ?? '',
                phone: paramsArray?.[2] ?? '',
                email: paramsArray?.[3] ?? '',
                country: 'Canada',
                streetAddress: paramsArray?.[4] ?? '',
                city: paramsArray?.[5] ?? '',
                region: paramsArray?.[6] ?? '',
                postalCode: paramsArray?.[7] ?? '',
                audience: {
                    curbing: paramsArray?.[8] === 'true',
                    resurfacing: paramsArray?.[9] === 'true',
                    grass: paramsArray?.[10] === 'true',
                    ottawa: paramsArray?.[11] === 'true',
                    golf: paramsArray?.[12] === 'true',
                    municipality: paramsArray?.[13] === 'true'
                },
                comment: paramsArray?.[14] ?? ''
            };
            if (!params.firstName) params.firstName = params.lastName;
            const startCalendly = paramsArray?.[15] === '1';
            dispatch(updateLead(params)); //update the state with the lead parameters
            const estimatorId = paramsArray?.[16];
            const estimator = (estimatorId === '0') 
                ? await getClosestEstimatorByAddress(`${params.streetAddress} ${params.city} ${params.region} ${params.country}`)
                : getEstimatorById(estimatorId);
            if (estimator?.id) dispatch(updateEstimator(estimator));
            if (startCalendly && estimatorCurrent?.calendar?.GTA) dispatch(updateCalendly(true)) // display calendly after the redirect
            else dispatch(updateCalendly(false));
            navigate('/', { replace: true });
        })();
    }, []);
    return null;
};

export default DecodeParams;